import type { EpicOption } from '@atlassian/jira-issue-field-epic-link/src/common/types/index.tsx';
import type { JiraEpic, JiraEpicLinkFieldInput } from './types.tsx';

export const transformDefaultEpicValue = ({ key, summary }: JiraEpic): EpicOption => ({
	label: summary,
	value: key,
});

export const mutateEpicLinkField = (
	{ value }: EpicOption,
	fieldId: string,
): JiraEpicLinkFieldInput => ({
	epicLinkField: {
		fieldId,
		epicLink: {
			issueKey: value,
		},
	},
});
